import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

/**
 * LineChart — Daily revenue trend
 * Props:
 *   data: Array<{ date, label, revenue, orderCount }>
 */
const LineChart = ({ data = [] }) => {
    const categories = data.map(d => d.label);
    const revenues = data.map(d => d.revenue);

    // Dynamic Y-axis max based on actual data
    const maxRevenue = Math.max(...revenues, 100);
    const yMax = Math.ceil(maxRevenue * 1.2 / 100) * 100;

    const options = {
        chart: {
            type: "area",
            style: {
                fontFamily: "inherit",
                color: "rgba(143, 143, 143, 1)",
            },
            backgroundColor: "transparent",
        },
        title: { text: "" },
        subtitle: { text: "" },
        credits: { enabled: false },
        legend: { enabled: false },
        xAxis: {
            categories: categories.length ? categories : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            crosshair: true,
            gridLineWidth: 0,
            lineWidth: 0,
            accessibility: { description: "Days" },
            labels: { style: { color: "rgba(143,143,143,1)", fontSize: "11px" } },
        },
        yAxis: {
            min: 0,
            max: yMax || 100,
            gridLineWidth: 0,
            labels: {
                formatter: function () {
                    return "$" + (this.value >= 1000 ? (this.value / 1000).toFixed(1) + "k" : this.value);
                },
                style: { color: "rgba(143,143,143,1)" },
            },
            title: { text: "" },
        },
        tooltip: {
            shared: true,
            formatter: function () {
                const day = this.points[0].key;
                const rev = this.points[0].y;
                const orders = data[this.points[0].point.index]?.orderCount ?? "—";
                return `<b>${day}</b><br/>Revenue: <b>$${rev.toFixed(2)}</b><br/>Orders: <b>${orders}</b>`;
            },
        },
        plotOptions: {
            series: {
                fillOpacity: 0.12,
                marker: {
                    enabled: false,
                    radius: 3,
                    symbol: "circle",
                    states: { hover: { enabled: true, radius: 5 } },
                },
            },
        },
        series: [
            {
                name: "Revenue",
                color: "var(--primary)",
                data: revenues.length ? revenues : [0, 0, 0, 0, 0, 0, 0],
                fillColor: {
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                        [0, "rgba(245, 126, 42, 0.25)"],
                        [1, "rgba(245, 126, 42, 0)"],
                    ],
                },
            },
        ],
    };

    return (
        <div className="chart">
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    );
};

export default LineChart;
